'use client';

import { useState } from 'react';
import { QueryClientProvider } from '@tanstack/react-query';
import dynamic from 'next/dynamic';
import { makeQueryClient } from '@/lib/query/query-client';
import { BackgroundSyncProvider } from '@/components/providers/background-sync-provider';

// Dynamic-import the devtools so the production bundle short-circuits to the
// `() => null` stub. `process.env.NODE_ENV` is statically inlined at build
// time, so the production branch never references the devtools chunk and it
// gets tree-shaken out entirely.
const ReactQueryDevtools =
  process.env.NODE_ENV !== 'production'
    ? dynamic(
        () =>
          import('@tanstack/react-query-devtools').then((m) => ({
            default: m.ReactQueryDevtools,
          })),
        { ssr: false },
      )
    : () => null;

export function QueryProvider({ children }: { children: React.ReactNode }) {
  const [queryClient] = useState(() => makeQueryClient());

  return (
    <QueryClientProvider client={queryClient}>
      {/* Drains the Dexie offline write queue on reconnect. Mounted here so it
          runs app-wide — it previously existed but was never mounted, so
          offline writes were promised and then silently discarded (OFF-01). */}
      <BackgroundSyncProvider>{children}</BackgroundSyncProvider>
      <ReactQueryDevtools initialIsOpen={false} />
    </QueryClientProvider>
  );
}
